import _ from 'lodash';
import natsort from 'natsort';

/**
 * @param {Array} array
 * @param {String} accessor
 * @return {Array}
 */
// eslint-disable-next-line import/prefer-default-export
export const naturalSort = (array = [], accessor) => {
  const sortingAlgorithm = natsort();

  if (!_.isEmpty(array)) {
    return array.sort((currentItem, nextItem) => {
      const currentItemValue = _.toLower(_.get(currentItem, accessor, currentItem));
      const nextItemValue = _.toLower(_.get(nextItem, accessor, nextItem));

      return sortingAlgorithm(currentItemValue, nextItemValue);
    });
  }

  return array;
};
